import React, { useRef, useState, useEffect } from 'react';
import { Box, Button, Typography, Slider, IconButton } from '@mui/material';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import PauseIcon from '@mui/icons-material/Pause';
import VolumeUpIcon from '@mui/icons-material/VolumeUp';

const AudioPlayerCard = () => {
  const audioRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [volume, setVolume] = useState(1);

  const togglePlay = () => {
    const audio = audioRef.current;
    if (!audio) return;
    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }
    setIsPlaying(!isPlaying);
  };

  const handleVolumeChange = (event, newValue) => {
    const audio = audioRef.current;
    setVolume(newValue);
    if (audio) audio.volume = newValue;
  };

  useEffect(() => {
    if (audioRef.current) {
      audioRef.current.volume = volume;
    }
  }, [volume]);

  return (
    <Box
      sx={{
        maxWidth: 900,
        mx: 'auto',
        mt: 6,
        p: 3,
        borderRadius: '24px',
        border: '2px solid #ccc',
        boxShadow: '0 12px 36px rgba(0,0,0,0.45)',
        backgroundColor: '#ffffff',
        display: 'flex',
        flexDirection: { xs: 'column', md: 'row' },
        alignItems: 'center',
        justifyContent: 'space-between',
        gap: 4,
        position: 'relative',
      }}
    >
      {/* Sección izquierda: reproductor */}
      <Box sx={{ flex: 1, textAlign: 'center' }}>
        <Typography variant="subtitle1" fontWeight="bold" mb={1}>
          Disfruta la señal en vivo
        </Typography>

        <Box
          component="img"
          src="/images/logo.png"
          alt="Radio Chukuta"
          sx={{
            width: 120,
            height: 120,
            borderRadius: '50%',
            mb: 2,
            animation: isPlaying ? 'spin 4s linear infinite' : 'none'
          }}
        />

        <audio ref={audioRef} src="https://stream.zeno.fm/cjkxri31g5ztv" />

        {/* Botón + texto alineado */}
        <Box
          onClick={togglePlay}
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: '#15A67D',
            cursor: 'pointer',
            mt: 1,
          }}
        >
          {isPlaying ? <PauseIcon fontSize="large" /> : <PlayArrowIcon fontSize="large" />}
          <Typography variant="subtitle1" fontWeight="bold" ml={1}>
            {isPlaying ? 'Pause' : 'Play'}
          </Typography>
        </Box>

        {/* Control de volumen */}
        <Box sx={{ width: '80%', mx: 'auto', mt: 2 }}>
          <Typography variant="body2">Volumen</Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <VolumeUpIcon sx={{ color: '#15A67D' }} />
            <Slider
              value={volume}
              onChange={handleVolumeChange}
              min={0}
              max={1}
              step={0.01}
              sx={{ color: '#15A67D' }}
            />
          </Box>
        </Box>
      </Box>

      {/* Sección derecha: descarga app */}
      <Box
        sx={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          textAlign: 'center',
        }}
      >
        <Typography variant="h6" fontWeight="bold">
          Disfruta nuestra señal en vivo a través de la aplicación móvil y conéctate a la cultura alteña desde cualquier parte del mundo
        </Typography>
        <Button
          variant="contained"
          color="primary"
          href="https://drive.google.com/file/d/16ZLfydg0DB7USdLHCGjbhQYUsFXufAab/view?usp=sharing"
          target="_blank"
          rel="noopener noreferrer"
          sx={{
            backgroundColor: '#15A67D',
            borderRadius: '10px',
            mt: 3,
            px: 3,
            fontWeight: 'bold'
          }}
        >
          DESCARGAR APLICACIÓN
        </Button>
      </Box>

      {/* Animación CSS */}
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </Box>
  );
};

export default AudioPlayerCard;
